export const heightText = () => {
  const mediaxl = 767
  const glob = document.querySelector('.js-height-all')
  if (window.innerWidth >= mediaxl && glob) {
    const elArrTitle = glob.querySelectorAll('.js-height-text')
    let maxHeight = 0
    const nodeToArray = [...elArrTitle]
    nodeToArray.forEach(el => {
      if (el.clientHeight > maxHeight) {
        maxHeight = el.clientHeight
      }
    })
    nodeToArray.forEach(el => {
      // eslint-disable-next-line no-param-reassign
      el.style.height = `${maxHeight}px`;
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/components/js-component/height-text.js